import { Sparkles } from "lucide-react";
import { confidenceLabel } from "../lib/aiMatchFields";

/**
 * V24 — Live "Data Completeness" + AI Confidence meter shown above forms.
 * Pure UI; pass `percent` (0-100) and `kind` ("lead" | "tutor") to render.
 */
export default function DataCompletenessMeter({ percent = 0, kind = "lead", testid = "ai-meter" }) {
    const { label, tone } = confidenceLabel(percent);
    const toneBg = {
        emerald: "bg-emerald-500",
        amber: "bg-amber-500",
        red: "bg-red-500",
    }[tone];
    const toneText = {
        emerald: "text-emerald-700 bg-emerald-50 border-emerald-200",
        amber: "text-amber-700 bg-amber-50 border-amber-200",
        red: "text-red-700 bg-red-50 border-red-200",
    }[tone];

    return (
        <div
            className={`flex items-center gap-3 p-3 rounded-xl border ${toneText}`}
            data-testid={`${testid}-root`}
            data-completeness={percent}
            data-confidence={label}
        >
            <Sparkles className="w-4 h-4 shrink-0" />
            <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between gap-2 text-[11px] font-semibold uppercase tracking-wider mb-1">
                    <span>{kind === "tutor" ? "Tutor Profile Completeness" : "Lead Data Completeness"}</span>
                    <span data-testid={`${testid}-pct`}>{percent}% · AI Confidence: <span data-testid={`${testid}-confidence`}>{label}</span></span>
                </div>
                <div className="h-1.5 w-full bg-white/60 rounded-full overflow-hidden">
                    <div
                        className={`h-full ${toneBg} transition-all duration-300`}
                        style={{ width: `${Math.max(2, Math.min(100, percent))}%` }}
                        data-testid={`${testid}-bar`}
                    />
                </div>
                <div className="text-[10px] mt-1 opacity-80">
                    {percent < 50 && "Add a few more details to improve AI tutor matching accuracy."}
                    {percent >= 50 && percent < 75 && "Looking good — a couple more fields will sharpen recommendations."}
                    {percent >= 75 && "Excellent — the AI has plenty of signal to recommend the perfect tutor."}
                </div>
            </div>
        </div>
    );
}
